/**
 * @public
 * Appends a `<STYLE>` tag into the `<HEAD>` element.
 *
 * @param {String} css: the CSS text to add
 * @param {String} id: (optional) id of the tag
 * @return {void}
 */
function addStyleToHead(css, id) {
  if (!css) {
    return;
  }

  if (id && document.getElementById(id)) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute('ref', 'stylesheet');
  style.setAttribute('type', 'text/css');

  if (id) {
    style.setAttribute('id', id);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  (document.head || document.getElementsByTagName('head')[0]).appendChild(style);
}

export default addStyleToHead;
